import { connection } from '../lib/engine.js';

/**
 * Полоска состояния связи.
 *
 * В онлайне не показывается: постоянный зелёный баннер только отнимает место.
 * Важно обратное — чтобы человек понимал, почему сообщение висит неотправленным.
 */
export function ConnectionBar() {
  if (connection.value === 'online') return null;

  return (
    <div class={`conn ${connection.value === 'offline' ? 'offline' : ''}`}>
      {connection.value === 'connecting'
        ? 'Подключаюсь…'
        : 'Нет связи с сервером. Сообщения уйдут, как только она вернётся'}
    </div>
  );
}
